import { Component, ElementRef, ViewChild, OnInit } from '@angular/core';
import { IonicPage, NavParams, ActionSheet, ActionSheetController, Config, NavController, ToastController, PopoverController, AlertController } from 'ionic-angular';

import { GolinksData } from '../../../providers/golinks-data';
import { GolinksEditPage } from './golinks-edit/golinks-edit';
import { UserData } from '../../../providers/user-data';
import { MandantenData } from '../../../providers/mandanten-data';
import { CommonData } from '../../../providers/common-data';
import { Storage } from '@ionic/storage';
import { localeDe } from '../../../providers/aggridlocale.de'


import { PbZonenactionsPage } from '../pbzonenactions/pbzonenactions';
import { AgGridAngular } from 'ag-grid-angular';
import { AllModules, Module } from '@ag-grid-enterprise/all-modules';

/**
 * Generated class for the pbzonenPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-golinks',
  templateUrl: 'golinks.html',
})
export class GolinksPage {
  @ViewChild('golinksGrid') agGrid: AgGridAngular;
  rowDataLinks:any;
  columnDefsLinks:any;
  gridOptionsLinks:any;
  searchQuery: string;
  bFilterActive: boolean;
  modules: Module[] = AllModules;
  constructor(
    public navCtrl: NavController
    , public navParams: NavParams
    , public goData: GolinksData
    , public userData: UserData
    , public mData: MandantenData
    , public popoverCtrl: PopoverController
    , public toastCtrl: ToastController
    , public common: CommonData
    , public storage: Storage
    , private alertCtrl: AlertController

  ) {
    this.bFilterActive = false;
    if(this.userData.usergroup_id == 1){
      this.columnDefsLinks = [
        {
          headerName: 'Id', field: 'id' , filter: "agNumberColumnFilter", resizable: true , width:70 
        }
        ,
        {
          headerName: 'Mandat', field: 'attributes.mandat_name' ,resizable: true , width:70 
        }

      ];      
      
    }
    else{
      this.columnDefsLinks = [];           
    }

    this.columnDefsLinks.push({headerName: 'Link', field: 'urlident', resizable: true, width:280, valueGetter: this.urlTextValueGetter.bind(this) });    
    this.columnDefsLinks.push({headerName: 'Aktiv', field: 'active', resizable: true, width:80, valueGetter: this.activeTextValueGetter.bind(this)   });    
    
    this.columnDefsLinks.push({headerName: 'Kategorie', field: 'attributes.pbkategorie_name', resizable: true, width:200  });
    this.columnDefsLinks.push({headerName: 'Zonen', field: 'attributes.pbzonen_name', resizable: true, width:200 });
    this.columnDefsLinks.push({headerName: 'Grundstücke', field: 'attributes.grundstuecke_name', resizable: true, width:200 });
    this.columnDefsLinks.push({headerName: 'Physische Parkkarte', field: 'attributes.physisch_name', resizable: true, width:100 });    
    
    this.columnDefsLinks.push({headerName: 'Erzeugt', field: 'created', resizable: true, width:140,  type:['dateColumn', 'nonEditableColumn']  });
    
    this.gridOptionsLinks = {         
      localeTextFunc: (key: string, defaultValue: string) =>  localeDe[key] || defaultValue,       
      isExternalFilterPresent: this.isExternalFilterPresent.bind(this),
      doesExternalFilterPass: this.doesExternalFilterPass.bind(this),
      onGridReady: this.gridReady.bind(this),
      onFilterChanged: this.filterChanged.bind(this),
      
      floatingFilter: true,
      defaultColDef : {
        filter:true,
        sortable: true
      }
    }
  }

  gridReady(event){
    
    //this.loadFilters();
  }
  
  filterChanged(event){
    /*
    var model = this.agGrid.gridOptions.api.getFilterModel();
    this.storage.set("pbzonefilter", model);        

    if(Object.keys(model).length !== 0){
      this.bFilterActive = true;
    }
    else{
      this.bFilterActive = false;
    }
    */
  }
  ionViewWillEnter() {
    
    this.loaddata();
  }  

  async loadFilters(){
    /*
    let pbzonefilter = await this.storage.get("pbzonefilter");
    if(!pbzonefilter){
      pbzonefilter = {
        archiviert: {
          filterType: 'text',
          type: 'equals',
          filter: 'nein',
        }
      };
    }
    this.agGrid.api.setFilterModel(pbzonefilter);     
    var model = this.agGrid.api.getFilterModel();
    */
  }

  ionViewDidEnter(){
    
  }

  activeTextValueGetter = function (params){
    return this.common.boolToText(params.data.active);
  }

  urlTextValueGetter = function (params){
    return this.common.golink + params.data.urlident;

  }

  mandateNameValueGetter = function (params) {
    if(this.mData){
      let m = this.mData.mandateby(params.data.mandate_id);
      if(m){
        return m.mandat;
      }
      else{
        return "";
      }  
    }
    else{
      return params.data.mandate_id;
    }    
  };

  loaddata() {
    this.common.showMessage('Daten werden geladen/aktualisiert', 2000);
    this.goData.load().then(res => {      
      if(!this.rowDataLinks || this.rowDataLinks.lenght==0){
        this.rowDataLinks = this.goData.data;
      }
      else{
        //-- Neue Eitnräge hinzufügen ------
        var transactionobject = {add:[], update:[]};
        for(let i=0; i<this.goData.added_ids.length; i++){
          let newData = this.goData.data.find(x => x.id === this.goData.added_ids[i]);          
          if(newData){
            transactionobject.add.push(newData);
          }    
        }
        this.goData.added_ids.length = 0;
        //-- Einzeleinträge aktualisieren ---
        //let rowsSelection = this.agGrid.api.getSelectedRows();
        let selectedNodes = this.agGrid.api.getSelectedNodes();
        //console.log(rowsSelection.length);
        for(let i=0; i<selectedNodes.length; i++){
          let actnode = selectedNodes[i];
          let newData = this.goData.data.find(x => x.id === actnode.data.id);
          if(newData){
            actnode.setData(newData);
            this.agGrid.api.onFilterChanged();
          }    
        }

        this.gridOptionsLinks.api.updateRowData(transactionobject);

        this.agGrid.api.sizeColumnsToFit();
        
      }
      
    });    
    
  }   

  showDetail(detail){
    this.navCtrl.push(GolinksEditPage, {id:detail.id});
  }
  add(){
    this.navCtrl.push(GolinksEditPage, {id:-1});    
  }

  isExternalFilterPresent() {
    return true;
  }

  doesExternalFilterPass(node) {
    return true;
  }  

  filterItems(ev: any) {
    this.searchGrid(ev);

  }     
  searchGrid(event){
    this.agGrid.api.setQuickFilter(this.searchQuery);
  }  

  gridRowDblClicked(event: any){ 
    this.showDetail(event.data)
  }

  gridClearFilter(){

    this.agGrid.api.setFilterModel(null);
    this.agGrid.api.onFilterChanged();
  }    


  async excelExport(){
    var params = {
      allColumns: true,
      onlySelected: false,
      fileName: "links.xlsx",
      sheetName: "Links",
      exportMode: "xlsx"
    };    
    //console.log("START EXCEL EXPORT");
    //console.log(this.gridOptions);
    this.gridOptionsLinks.api.exportDataAsExcel(params);
  }  



}




// WEBPACK FOOTER //
// ./src/pages/parkbewilligungen/golinks/golinks.ts